<template>
    <b-row>
        <div class="details-black-card">
            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.lifetimegrn') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">₹ {{ dataObj.LifeTimeGRN}}</p>
                </b-col>
            </b-row>
            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.paid') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">₹ 0</p>
                </b-col>
            </b-row>
            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.discount') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">₹ 0</p>
                </b-col>
            </b-row>
            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.balance') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">₹ 0</p>
                </b-col>
            </b-row>
            <b-row class="py-2">
                <b-col lg="5" md="2" sm="6" cols="12">
                    <p class="grey-label">{{ $t('blackboxInfo.Availablecreditdays') }}</p>
                </b-col>
                <b-col lg="7" md="10" sm="6" cols="12">
                    <p class="white-filed">0</p>
                </b-col>
            </b-row>
        </div>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss">
.details-black-card {
    background-color: #161B22;
    border-radius: 15px;
    padding: 10px;
}

.grey-label {
    color: #999999;
    font-size: 14px;
    text-align: left;
}

.white-filed {
    color: #FFFFFF;
    font-size: 14px;
    text-align: right;
}
</style>